// src/pages/admin/AdminLayout.js (unchanged from previous correction)
import React, { useState } from 'react';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';

const { Sider, Content } = Layout;

const AdminLayout = ({ children, onLogout, menuItems = [] }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      if (onLogout) {
        onLogout();
        navigate('/signin');
      }
    } else {
      navigate(key);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={250}
        style={{ background: '#001529' }}
      >
        <Sidebar
          collapsed={collapsed}
          handleMenuClick={handleMenuClick}
          menuItems={menuItems}
        />
      </Sider>
      <Layout>
        <Content style={{ padding: '20px', background: '#f0f2f5' }}>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;